import { UserInfoModel } from '../pages/user/models/user.model';

export const RoleChecker = (user: UserInfoModel | null): number => {
  if (user && user?.role_id) {
    if (typeof user.role_id === 'number') return user.role_id;
    if (typeof user.role_id === 'object' && user.role_id !== null)
      return (user.role_id as { level: number }).level;
    return 5;
  } else {
    return 5;
  }
};
